import { memo, useCallback } from "react"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { getViewState, setNewViewstate } from "../GlobalViewState"

const genericClasses = "flex items-center justify-center h-9 w-9 cursor-pointer"

const ZoomControls = memo(({ isLight }: { isLight: boolean }) => {
    const incrementZoom = useCallback(
        () => setNewViewstate({ ...getViewState(), zoom: Math.min(23, getViewState().zoom + 0.5) }),
        []
    )
    const decrementZoom = useCallback(
        () => setNewViewstate({ ...getViewState(), zoom: Math.max(4, getViewState().zoom - 0.5) }),
        []
    )

    return (
        <div className="flex pointer-events-auto rounded-full">
            <div
                className={classNames(
                    genericClasses,
                    "rounded-l-full border-l border-y hover:border-r pr-px hover:pr-0",
                    {
                        "bg-black-600 hover:bg-gray-700 text-gray-0 border-white-300 hover:border-white-400":
                            !isLight,
                        "bg-white-500 hover:bg-gray-0 text-gray-800 border-black-300 hover:border-black-400":
                            isLight,
                    }
                )}
                onClick={decrementZoom}
            >
                <Icons.SmallIcon Icon={Icons.Minus} className="translate-x-0.5" />
            </div>
            <div
                className={classNames(
                    genericClasses,
                    "rounded-r-full border-r border-y hover:border-l pl-px hover:pl-0",
                    {
                        "bg-black-600 hover:bg-gray-700 text-gray-0 border-white-300 hover:border-white-400":
                            !isLight,
                        "bg-white-500 hover:bg-gray-0 text-gray-800 border-black-300 hover:border-black-400":
                            isLight,
                    }
                )}
                onClick={incrementZoom}
            >
                <Icons.SmallIcon Icon={Icons.Plus} className="-translate-x-0.5" />
            </div>
        </div>
    )
})

ZoomControls.displayName = "ZoomControls"

export default ZoomControls
